import React, { useState } from 'react'
import { Box, IconButton, TextField } from '@mui/material'
import { styled } from "@mui/material/styles"
import { ArrowUp } from 'phosphor-react'

const StyledInput = styled(TextField)(() => ({
  '& .MuiInputBase-input': {
    padding: '12px 50px 12px 16px',
    lineHeight: '1.5',
    minHeight: '24px',
    wordWrap: 'break-word',
    whiteSpace: 'pre-wrap',
  },
  '& .MuiFilledInput-root': {
    borderRadius: '25px',
    overflow: 'hidden',
    maxHeight: '150px',
    transition: 'all 0.2s ease-in-out',
    minHeight: '48px',
    padding: 0,
    position: 'relative',
  },
  '& .MuiInputBase-root': {
    maxHeight: '150px',
    overflowY: 'auto',
    alignItems: 'flex-start',
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(196, 191, 191, 0.2)',
      borderRadius: '25px',
    },
  }
}));

const ChatInput = ({ onSendMessage, disable }) => {
  const [message, setMessage] = useState('');

  const handleInputChange = (e) => {
    setMessage(e.target.value || '');
  };

  const handleSendMessage = () => {
    if (message.trim()) {
      onSendMessage(message.trim());
      setMessage('');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      if (!e.shiftKey) {
        e.preventDefault();
        handleSendMessage();
      }
      // If Shift+Enter is pressed, allow default behavior (new line)
    }
  };

  return (
    <Box sx={{
      display: 'flex',
      width: '100%',
      justifyContent: 'center'
    }}>
      {/* Text input wrapper - contains both TextField and IconButton */}
      <Box sx={{
        flex: 1,
        position: 'relative',
        backgroundColor: 'white',
        borderRadius: '25px',
        overflow: 'hidden'
      }}>
        <StyledInput
          sx={{ width: '100%' }}
          multiline
          minRows={1}
          value={message}
          onChange={handleInputChange}
          onKeyDown={handleKeyPress}
          placeholder='Message TDS'
          variant="filled"
          disabled={disable}
          size="small"
          InputProps={{
            disableUnderline: true,
            sx: {
              paddingRight: '0px'
            }
          }}
        />
        <IconButton
          onClick={handleSendMessage}
          disabled={disable}
          sx={{
            backgroundColor: disable ? "white" : "black",
            color: disable ? "white" : "white",
            width: "40px",
            height: "40px",
            borderRadius: '20px',
            position: 'absolute',
            right: 4,
            bottom: 4,
            '&:hover': {
              backgroundColor: disable ? "white" : "grey"
            }
          }}
        >
          <ArrowUp size={25} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default ChatInput;